import React from 'react'
import { Link } from 'react-router-dom'
const Begin = () => {
    return (
        <div className="signInUp">
            <div className="signInUp__wrapper">
                <div className="signInUp__wrapper__title">
                    <h1>Kinema</h1>
                    <p>O seu gerenciador de filmes e séries</p>
                </div>
                <div className="signInUp__wrapper__buttons">
                    <Link to="/login" className="defaultBtn">Entrar</Link>
                    <Link to="/signup" className="defaultBtn defaultBtn--reverse">Cadastrar</Link>
                </div>
            </div>
        </div>
    )
}

export default Begin
